import { createFileRoute, redirect } from "@tanstack/react-router";
import { ensureElementVisible } from "@/lib/route-guards";

// Dawny ekran odpowiedzi na zgłoszenia — Robaczek obsługuje teraz helpdesk.
export const Route = createFileRoute("/_auth/konfiguracja/issue-resolve/")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(context.queryClient, "sidebar.helpdesk.obsluga", location.href);
		throw redirect({ to: "/helpdesk", search: { category: "robaczek" }, replace: true });
	},
});
